"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_ADDRESS = void 0;
exports.getPlaceholder = getPlaceholder;

function getPlaceholder(recordType, contentType) {
  switch (recordType) {
    case 'address':
      return 'Enter an Ethereum address';

    case 'content':
      if (contentType === 'contenthash') {
        return 'Enter a content hash (eg: ipfs://..., bzz://..., onion://..., onion3://...)';
      } else {
        return 'Enter a content';
      }

    default:
      return '';
  }
}

var EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000';
exports.EMPTY_ADDRESS = EMPTY_ADDRESS;